import { Typography } from "@timeedit/ui-components";
import { ActivityView } from "../CalendarListView/GroupListView";
import { createActivityEvents, EventWithRelated } from "./helpers";

export interface EventModalContentProps {
  eventsWithRelated: Partial<EventWithRelated>[];
  title: React.JSX.Element;
}

export function GroupModalContent({
  eventsWithRelated,
  title,
}: EventModalContentProps): React.JSX.Element {
  if (eventsWithRelated.length === 0) {
    return <Typography.Text>No events to display!</Typography.Text>;
  }

  const activityEvents = createActivityEvents({ eventsWithRelated });

  return (
    <div>
      {title}
      <ActivityView events={activityEvents} />
    </div>
  );
}
